import { onMounted, ref, watch } from 'vue';

import { useBreakpoints } from '@/composables/breakpoint';

export const useBodyWidth = () => {
  const { windowDimensions } = useBreakpoints();

  const bodyWidth = ref<number>(0);

  const syncBodyWidth = () => {
    if (IS_SSR) {
      return;
    }
    bodyWidth.value = document.body.clientWidth;
  };

  onMounted(() => {
    syncBodyWidth();
  });

  watch(() => windowDimensions.value.width, syncBodyWidth);

  return {
    bodyWidth,
  };
};
